/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type InvoiceTransactionResponseDto = {
    id: string;
    transactionType: InvoiceTransactionResponseDto.transactionType;
    details?: string | null;
    date: string;
    value: number;
    deletedAt?: string | null;
};
export namespace InvoiceTransactionResponseDto {
    export enum transactionType {
        CASH = 'CASH',
        WRITE_OFF = 'WRITE_OFF',
        CREDIT = 'CREDIT',
        CREDIT_ALLOCATION = 'CREDIT_ALLOCATION',
        REFUND = 'REFUND',
    }
}

